export default __webpack_public_path__ + "static/avatar-megumi-86ff1b8b58d2fa5c06b5deedc140f8d5.png";